import { Injectable } from '@angular/core';
import { getActionTypeFromInstance, NgxsPlugin, setValue } from '@ngxs/store';
import { merge } from 'lodash-es';
import {
  SetAllGlobalContextProperties,
  SetGlobalContextProperty,
  UpdateGlobalContext,
} from '@app/state/widgets/widgets.actions';

@Injectable()
export class NgxsWidgetPluginService implements NgxsPlugin {
  handle(
    state: any,
    event: any,
    next: (state: any, mutation: any) => any
  ): any {
    const type = getActionTypeFromInstance(event);
    let nextState = state;

    if (type === UpdateGlobalContext.type) {
      const globalContextEvent = event as UpdateGlobalContext;
      nextState = merge({}, nextState, globalContextEvent.context);
      nextState = setValue(
        nextState,
        'widgets.lastGlobalActionResult',
        globalContextEvent.context
      );
    } else if (type === SetGlobalContextProperty.type) {
      const setGlobalContextPropertyEvent = event as SetGlobalContextProperty;
      nextState = setValue(
        nextState,
        setGlobalContextPropertyEvent.context.path,
        setGlobalContextPropertyEvent.context.value
      );
      nextState = setValue(
        nextState,
        'widgets.lastGlobalActionResult',
        setGlobalContextPropertyEvent.context
      );
    } else if (type === SetAllGlobalContextProperties.type) {
      const SetAllGlobalContextPropertiesEvent =
        event as SetAllGlobalContextProperties;
      const setNestedValues = (baseState, baseObject, basePath = '') => {
        let resultState = baseState;

        if (baseObject && typeof baseObject === 'object') {
          // handle arrays as comma delimited strings
          if (Array.isArray(baseObject)) {
            resultState = setValue(resultState, basePath, baseObject);
          } else {
            Object.entries(baseObject).forEach(([key, value]) => {
              const currentPath = basePath ? `${basePath}.${key}` : key;
              if (value !== null && typeof value === 'object') {
                resultState = setNestedValues(resultState, value, currentPath);
              } else {
                resultState = setValue(resultState, currentPath, value);
              }
            });
          }
        } else if (basePath) {
          resultState = setValue(resultState, basePath, baseObject);
        }

        return resultState;
      };

      nextState = setNestedValues(
        nextState,
        SetAllGlobalContextPropertiesEvent.context
      );
      nextState = setValue(
        nextState,
        'widgets.lastGlobalActionResult',
        SetAllGlobalContextPropertiesEvent.context
      );
    }

    return next(nextState, event);
  }
}
